export const hexToRgba = (hex, alpha = 0.3) => {
    // convert hex to RGB values
    var r = parseInt(hex.substring(1, 3), 16);
    var g = parseInt(hex.substring(3, 5), 16);
    var b = parseInt(hex.substring(5, 7), 16);

    // create an rgba color string
    var rgbaColor = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';

    return rgbaColor;
}